import { toast as toastApi, useToasts } from '@/lib/toast';
import { Toast } from '@/ui';

/** Renders the toast queue at the bottom centre. Mount once in the root layout. */
export function ToastHost() {
  const items = useToasts();
  if (!items.length) return null;
  return (
    <div className="pointer-events-none fixed bottom-6 left-1/2 z-200 flex -translate-x-1/2 flex-col items-center gap-2">
      {items.map((t) => (
        <div key={t.id} className="ui-toast-in pointer-events-auto">
          <Toast tone={t.tone} className="w-auto max-w-[460px] min-w-[320px]">
            <span className="flex-1">{t.message}</span>
            {t.undo ? (
              <button
                type="button"
                className="ml-2 cursor-pointer text-[13px] font-semibold text-palette-blue-30 hover:underline"
                onClick={() => {
                  t.undo?.();
                  toastApi.dismiss(t.id);
                }}
              >
                Undo
              </button>
            ) : null}
          </Toast>
        </div>
      ))}
    </div>
  );
}
